export const CSS_CLASSES = {
	hidden: "smartyAddress__hidden",
	matchedText: "smartyAddress__matchedText",
	smartyLogoDark: "smartyAddress__smartyLogoDark",
	smartyLogoLight: "smartyAddress__smartyLogoLight",
	autocompleteSuggestionsElement: "smartyAddress__autocompleteSuggestionsElement",
	poweredBy: "smartyAddress__poweredBy",
	dropdownElement: "smartyAddress__dropdownElement",
	autocompleteSuggestionsWrapperElement: "smartyAddress__autocompleteSuggestionsWrapperElement",
	srOnly: "smartyAddress__srOnly",
	autocompleteAddress: "smartyAddress__autocompleteAddress",
	addressWrapper: "smartyAddress__addressWrapper",
	autocompleteSuggestionEntries: "smartyAddress__autocompleteSuggestionEntries",
	autocompleteSuggestion: "smartyAddress__autocompleteSuggestion",
	secondaryAutocompleteSuggestion: "smartyAddress__secondaryAutocompleteSuggestion",
	entriesChevron: "smartyAddress__entriesChevron",
	entriesChevronUp: "smartyAddress__entriesChevronUp",
	showAllSecondaries: "smartyAddress__showAllSecondaries",
	colorDynamic: "smartyAddress__color_dynamic",
	positionDynamic: "smartyAddress__position_dynamic",
} as const;

export const CSS_PREFIXES = {
	instance: "smartyAddress__instance_",
	dropdown: "smartyAddress__dropdown_",
	autocompleteSuggestion: "smartyAddress__autocompleteSuggestion_",
} as const;
